import { LangEnum } from '@enums';
import { FC } from 'react';
import { TabsPanel } from '@sharedComponents/TabsPanel';
import './index.scss';
import { FormContainer } from '@components/Pages/LettersPage/Form';
import { TemplateEditor } from '@components/Pages/LettersPage/TemplateEditor';

export interface EditorContainerProps {
  onFormChange: (...args) => void;
  lang: LangEnum;
  isOriginUpdatable: boolean;
}

export const EditorContainer: FC<EditorContainerProps> = ({
  onFormChange,
  lang,
  isOriginUpdatable,
}) => {
  const tabsList = [
    {
      label: 'Content Editor',
      content: <FormContainer lang={lang} onChange={onFormChange} />,
      testId: 'tab-content',
    },
    {
      label: 'Sample Editor',
      content: <TemplateEditor />,
      testId: 'tab-template',
    },
  ];

  const tabPanelClassesGenerator = (tabLabel: string) => ({
    root: `tab-panel-${tabLabel.toLocaleLowerCase().replace(' ', '-')}`,
  });

  return isOriginUpdatable ? (
    <div className={'editor-container'} data-testid="editor-tabs">
      <TabsPanel tabsList={tabsList} tabPanelClassesGenerator={tabPanelClassesGenerator} />
    </div>
  ) : (
    <FormContainer lang={lang} onChange={onFormChange} />
  );
};
